export const bengaluruGps = { latitude: 12.93921899999998, longitude: 77.69529499999999 };

export const bengaluruBounds = {
	north: 13.471908,
	south: 12.70449,
	east: 78.046592,
	west: 77.318748,
};
